import { render, staticRenderFns } from "./createStaffModal.vue?vue&type=template&id=69964dc2&"
import script from "./createStaffModal.vue?vue&type=script&lang=js&"
export * from "./createStaffModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69964dc2')) {
      api.createRecord('69964dc2', component.options)
    } else {
      api.reload('69964dc2', component.options)
    }
    module.hot.accept("./createStaffModal.vue?vue&type=template&id=69964dc2&", function () {
      api.rerender('69964dc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/branches/components/createStaffModal.vue"
export default component.exports